import { render, staticRenderFns } from "./TemplateEMAIL2.vue?vue&type=template&id=ec6f07e0&"
import script from "./TemplateEMAIL2.vue?vue&type=script&lang=js&"
export * from "./TemplateEMAIL2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports